<template>
  <div>
    <navbar :hasSearch="true" />
    <div id="content">
      <div class="row">
        <div class="col-md-6 pb-3">
          <div class="card h-100">
            <ol class="breadcrumb lighten-4 my-auto">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'landingPage' }">
                  <a class="black-text" href="#">Home</a>
                </router-link>
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
              <li class="breadcrumb-item active font-weight-bold">
                Erroneous Transfers
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
            </ol>
          </div>
        </div>
        <quick-links></quick-links>
      </div>

      <div class="content_body">
        <div class="container-fluid no-pad bg-white brs pt-4">
          <div class="col-sm-12">
          <h4>Erroneous Transfers</h4>

            <div class="row">
              <div class="col-auto">
                <label for="" class="d-fle align-items-center">
                  <div>Received After</div>
                  <el-date-picker
                    v-model="filterFromStartDate"
                    format="dd.MM.yyyy"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="Received After"
                  ></el-date-picker>
                </label>
              </div>
              <div class="col-auto">
                <label for="" class="d-fle align-items-center">
                  <div>Received Before</div>
                  <el-date-picker
                    v-model="filterFromEndDate"
                    format="dd.MM.yyyy"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="Received Before"
                  ></el-date-picker>
                </label>
              </div>

              <div class="col-auto">
                <label for="" class="d-fle align-items-center">
                  <div>Status</div>
                  <b-form-select v-model="filterByStatus">
                    <option :value="undefined">All</option>
                    <option v-for="opt of statusOptions" :key="opt" :value="opt">{{opt}}</option>
                  </b-form-select>
                </label>
              </div>

              <div class="col-auto">
                <label for="" class="d-fle align-items-center">
                  <div>Mpxn</div>
                  <input v-model="filterByMpxn" class="form-control"/>
                </label>
              </div>

              <div class="col-auto">
                <label for="" class="d-fle align-items-center">
                  <div>Fuel</div>
                  <b-form-select v-model="filterByServiceType">
                    <option :value="undefined">All</option>
                    <option v-for="opt of serviceTypeOptions" :key="opt" :value="opt">{{opt}}</option>
                  </b-form-select>
                </label>
              </div>

              <div class="col-auto">
                <switches
                  v-model="filterByRespond"
                  class="col-auto text-center"
                  type-bold="true"
                  theme="bootstrap"
                  color="success"
                  text-enabled="Hide non actionable ETs"
                  text-disabled="Hide non actionable ETs"
                ></switches>
              </div>

              <div class="col-auto my-auto">
                <button class="btn" @click="reestFilters()">Reset All Filters</button>
              </div>
            </div>

          <div class="row">
            <div class="col-12">
              <b-table
                id="bills_table"
                striped
                :fields="tableFields"
                :items="etsFiltered"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="loading"
              >
                <template v-slot:table-busy>
                  <b-row align-h="center">
                    <propagate-loader
                      class="mb-3"
                      :color="primaryColour"
                      :size="16"
                    ></propagate-loader>
                  </b-row>
                </template>

                <template v-slot:Received="{item}">
                  {{ toDate(item.Received) }}
                </template>

                <template v-slot:Action="{item}">
                  <button class="btn btn-info btn-sm"
                    data-toggle="modal"
                    data-target="#ViewET"
                    @click="previewEt = item; viewOnly = true"
                  >
                    View
                  </button>
                  <button v-if="item.AllowResponse" class="btn btn-success btn-sm ml-3"
                    data-toggle="modal"
                    data-target="#ViewET"
                    @click="previewEt = item; viewOnly = false">Respond</button>
                </template>
              </b-table>
            </div>

            <div class="col-12">
              <b-pagination
                  class="my-auto d-flex justify-content-center align-items-center mx-auto"
                  v-model="currentPage"
                  :total-rows="etsFiltered.length"
                  :per-page="perPage"
                  aria-controls="bills_table"
                  @input="scrollToTop()"
                >
                  <template v-slot:first-text>
                    <i
                      class="fas fa-angle-double-left fa-2x pointer"
                    ></i>
                  </template>
                  <template v-slot:prev-text>
                    <i
                      class="fas fa-chevron-left fa-2x pointer"
                    ></i>
                  </template>
                  <template v-slot:next-text>
                    <i
                      class="fas fa-chevron-right fa-2x pointer"
                    ></i>
                  </template>
                  <template v-slot:last-text>
                    <i
                      class="fas fa-angle-double-right fa-2x pointer"
                    ></i>
                  </template>
                </b-pagination>
            </div>
          </div>
        </div>

          <div class="row p-3 justify-content-center">
            <div class="col-auto">
              <button
                class="btn btn-hc"
                data-toggle="modal"
                data-target="#CreateET"
              >
                Create New
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="ViewET"
        tabindex="-1"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="col-auto">
                <h3>{{viewOnly ? 'View' : 'Respond'}} - {{ previewEtType }}</h3>
              </div>
            </div>

            <div class="container-fluid">
              <div class="modal-body">
                <ViewElectricity
                  v-if="previewEtType === 'Electricity'"
                  :key="'electricity-' + previewEt.Id"
                  v-bind="previewEt"
                  :view-only="viewOnly"
                  @refresh="loadETs"/>
                <ViewGas
                    v-else-if="previewEtType === 'Gas' && showGasComponents"
                    :key="'gas-' + previewEt.Id"
                    v-bind="previewEt"
                  :view-only="viewOnly"
                  @refresh="loadETs"/>
              </div>

            <div class="col-auto">
              <button class="btn my-3"
              v-if="viewOnly"
              data-dismiss="modal"
                    data-target="#ViewET"
                    >Cancel</button>
            </div>
            </div>
          </div>
        </div>
      </div>

      <CreateET @refresh="loadETs" />
    </div>
  </div>
  <!-- content close -->
</template>
<script>
import Navbar from '@/components/Navbar.vue';
import QuickLinks from '@/components/QuickLinks.vue';
import moment from 'moment';
import Vue from 'vue';
import _filters from '@/mixins/filters.js';

import ViewElectricity from '@/components/modals/ETs/ViewElectricity.vue';
import ViewGas from '@/components/modals/ETs/ViewGas.vue';
import CreateET from '@/components/modals/ETs/Create.vue';

export default {
  name: 'ETs',
  components: {
    Navbar,
    QuickLinks,
    ViewElectricity,
    ViewGas,
    CreateET,
  },
  mixins: [_filters],
  data() {
    return {
      ets: undefined,
      loading: true,

      perPage: 10,
      currentPage: 1,

      previewEt: undefined,
      viewOnly: true,

      filterByStatus: undefined,
      filterByMpxn: '',
      filterByServiceType: undefined,
      filterByRespond: false,

      filterFromStartDate: undefined,
      filterFromEndDate: undefined,
    };
  },
  computed: {
    etsFiltered() {
      let ets = this.ets;

      if (this.filterByStatus)
        ets = ets.filter((et) => et.Status === this.filterByStatus);

      if (this.filterByMpxn)
        ets = ets.filter(
          (et) => et.MPxN && et.MPxN.toString().includes(this.filterByMpxn)
        );

      if (this.filterByServiceType)
        ets = ets.filter((et) => et.ServiceType === this.filterByServiceType);

      if (this.filterFromStartDate)
        ets = ets.filter((et) =>
          moment(et.Received).isSameOrAfter(this.filterFromStartDate, 'day')
        );

      if (this.filterFromEndDate)
        ets = ets.filter((et) =>
          moment(et.Received).isSameOrBefore(this.filterFromEndDate, 'day')
        );

      if (this.filterByRespond) ets = ets.filter((et) => et.AllowResponse);

      return ets;
    },
    statusOptions() {
      if (!this.ets) return;

      return new Set(this.ets.map((et) => et.Status));
    },
    showGasComponents() {
      return Vue.config.honeycomb.supplierId === 'DUAL';
    },
    serviceTypeOptions() {
      if (!this.ets) return;

      if (Vue.config.honeycomb.supplierId === 'VNQT') {
        return new Set(['Electricity']);
      }
      return new Set(this.ets.map((et) => et.ServiceType));
    },

    previewEtType() {
      return this.previewEt && this.previewEt.ServiceType;
    },
    primaryColour() {
      return Vue.config.honeycomb.theme;
    },
    accessToken() {
      return this.$auth.accessToken;
    },
    xsrfToken() {
      return this.$auth.xsrfToken;
    },
    flowbot() {
      return {
        gas: Vue.config.honeycomb.flowbot.gas.domain,
        elec: Vue.config.honeycomb.flowbot.electricity.domain,
        Gas: Vue.config.honeycomb.flowbot.gas.domain,
        Electricity: Vue.config.honeycomb.flowbot.electricity.domain,
      };
    },
    tableFields() {
      return {
        Received: { label: 'Date received', sortable: true },
        InitiatingSupplierId: { label: 'Initiator ID' },
        Status: { label: 'Status' },
        ServiceType: { label: 'Fuel' },
        MPxN: { label: 'MPxN' },
        SSD: { label: 'SSD' },
        SED: { label: 'SED' },
        Action: { label: 'Action' },
      };
    },
  },
  methods: {
    async loadETs() {
      try {
        const url = '/api/v1/erroneoustransfers';
        const supplierId = Vue.config.honeycomb.supplierId;

        let gasETs = { Records: [] };
        let elecETs = { Records: [] };

        if (supplierId === "DUAL") {
          // Keep existing functionality for DUAL
          gasETs = (await this.$http.get(
              `https://${this.flowbot.gas}${url}`,
              { withCredentials: true }
          )).data;

          elecETs = (await this.$http.get(
              `https://${this.flowbot.elec}${url}`,
              { withCredentials: true }
          )).data;
        } else if (supplierId === "VNQT") {
          // For UC only fetch elecETs
          elecETs = (await this.$http.get(
              `https://${this.flowbot.elec}${url}`,
              { withCredentials: true }
          )).data;
        }

        this.ets = [
          ...gasETs.Records.map((s) => ({ ...s, ServiceType: 'Gas' })),
          ...elecETs.Records.map((s) => ({ ...s, ServiceType: 'Electricity' })),
        ]
            .map((et) => ({
              ...et,
              AllowResponse: Vue.config.honeycomb.supplierId === 'VNQT'
                  ? /Proposed/.test(et.Status) && et.InitiatingSupplierId !== 'VNQT'
                  : /Proposed/.test(et.Status) && !['DUE', 'DUAL'].includes(et.InitiatingSupplierId)
            }))
            .sort((a, b) => (a.Received < b.Received ? 1 : -1));

        await this.loadRegistrations();
        this.mapSupplyDates();
      } finally {
        this.loading = false;
      }
    },

    async loadRegistrations() {
      this.ets = await Promise.all(
        this.ets.map(async (et) => ({
          ...et,
          Registration: await this.loadRegistration(
            et.RegistrationId,
            et.ServiceType
          ),
        }))
      );

      this.ets = this.ets.map((et) => ({
        ...et,
        MPxN:
          et.Registration &&
          et.Registration.MeterPoint &&
          (et.Registration.MeterPoint.Mprn || et.Registration.MeterPoint.Mpan),
      }));
    },

    mapSupplyDates() {
      this.ets = this.ets.map((et) => ({
        ...et,
        SSD: et.Registration && this.toDate(et.Registration.EffectiveFrom),
        SED:
          et.Registration && et.Registration.EffectiveTo
            ? this.toDate(et.Registration.EffectiveTo)
            : 'Ongoing',
      }));
    },

    async loadRegistration(registrationId, serviceType) {
      try {
        const url = `/api/v1/Registrations/${registrationId}`;
        const { data } = await this.$http.get(
          `https://${this.flowbot[serviceType]}${url}`,
          { withCredentials: true }
        );

        return data;
      } catch {
        return;
      }
    },

    scrollToTop() {
      document.getElementById('bills_table').scrollIntoView();
    },

    toDate(date) {
      return moment(date).format('ll');
    },

    reestFilters() {
      this.filterByStatus = undefined;
      this.filterByMpxn = '';
      this.filterByServiceType = undefined;
      this.filterByRespond = false;
      this.filterFromStartDate = undefined;
      this.filterFromEndDate = undefined;
    },
  },

  async mounted() {
    await this.loadETs();
  },
};
</script>
